function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnGnbClose = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 118",
  style: {
    fill: "none"
  },
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 131"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 48",
  d: "M20.643 23.221h22",
  transform: "rotate(45 31.279 3.764)",
  style: {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 49",
  d: "M20.643 23.221h22",
  transform: "rotate(-45 18.143 37.236)",
  style: {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnGnbClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "36e2a17710ad0d0fdb3c51352b7e391b.svg";